import { render } from "./modal_reglementfacture.vue?vue&type=template&id=2bbd389e&scoped=true"
import script from "./modal_reglementfacture.vue?vue&type=script&lang=js"
export * from "./modal_reglementfacture.vue?vue&type=script&lang=js"

import "./modal_reglementfacture.vue?vue&type=style&index=0&id=2bbd389e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbd389e"]])

export default __exports__